document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.button-print').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            window.print();
        });
    });
});